
import TopCategoryTile from "./TopCategoryTile";

export default {
  components: { TopCategoryTile },

  props: { fields: { type: Array, default: () => {} } },
};
